import {
    put, takeLatest, call
} from 'redux-saga/effects';
import { authenticatedAxios } from '../client';
import {
    SUBMIT_SUPPORT_FORM, submitSupportForm
} from "../actions/support";

function* handleSubmitSupportForm({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let data;
    try {
        const params = new URLSearchParams();
        params.append('account_id', payload.accountId);
        params.append('context', payload.context);
        params.append('subject', 'Support Request');
        params.append('gift_visible_phone_id', payload.giftYaId);
        params.append('order_visible_phone_id', payload.phoneId);
        params.append('name', payload.name);
        params.append('email', payload.email);
        params.append('phone', payload.phone);
        params.append('message', payload.message);

        yield call(authenticatedAxios.post,
            `${window.api_url}/site/zendesk/support-ticket`,
            params
        );

        data = {
            submitted: true
        };

    } catch (error) {
        yield put(submitSupportForm(error, {}, true));
    }
    yield put(submitSupportForm(data, {'sent': true}));
}
export function* watchSubmitSupportForm() {
    yield takeLatest(SUBMIT_SUPPORT_FORM, handleSubmitSupportForm);
}